import { stage } from '../services/abstract.js';

export default function useTheme () {
    const theme = document.querySelector('body').getAttribute('theme');

    if (theme === 'cuota-ya') {
        return {
            name: 'cuota-ya',
            label: 'Cuota Ya',
            title: 'Cuota Ya',
            colorPrimary: '#bd3739',
            colorAccent: '#cd5c5c',
            linkUrl: `https://cuota-ya-sign${stage}.dinclin.com`,
        };
    }

    return {
        name: 'demo',
        label: 'tu empresa',
        title: 'Demo',
        colorPrimary: '#b61989',
        colorAccent: '#b61989',
        linkUrl: `https://demo-sign${stage}.dinclin.com`,
    };
}
